import {ProposedService} from '../../server/routes/availability/types';
import {AvailabilityState} from '../store/slices/availability/slice';

export const getSelectedServicesData = (
  availabilityState: AvailabilityState,
): string => {
  const selectedServices = availabilityState.data.services.map((service) => {
    const currentServices: ProposedService = {
      menuItemId: service.id,
      optionIds: service.skuIds,
    };
    if (availabilityState.selected.employeeMultiSelect[service.id]) {
      currentServices.employeeId =
        availabilityState.selected.employeeMultiSelect[service.id];
    }
    return currentServices;
  });

  return JSON.stringify(selectedServices);
};
